export default __webpack_public_path__ + "static/media/review18.c68051cd.jpg";